module.exports = __webpack_public_path__ + "static/media/airtel_icon.51c09dfe.png";